import { render, staticRenderFns } from "./right_panel_arrivals.vue?vue&type=template&id=8ecc2bfc&scoped=true"
import script from "./right_panel_arrivals.vue?vue&type=script&lang=js"
export * from "./right_panel_arrivals.vue?vue&type=script&lang=js"
import style0 from "./right_panel_arrivals.vue?vue&type=style&index=0&id=8ecc2bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecc2bfc",
  null
  
)

export default component.exports